const skillsFront = [
  { type: 'HTML, CSS', level: 90 },
  { type: 'JavaScript', level: 80 },
  { type: 'Bootstrap', level: 90 },
  { type: 'React.js', level: 80 },
  { type: 'Photoshop', level: 90 },
  { type: 'Web Design', level: 90 }
];

export default skillsFront;
